<template>
  <v-container fill-height fluid grid-list-xl v-if="banks.length">
    <v-layout wrap>
      <v-flex xs12 md4>
        <material-card color="orange" title="Banks">
          <v-combobox
            :items="banks"
            v-model="selectedBank"
            item-text="bank_alias"
            label="Select a bank account"
          ></v-combobox>
          <v-card-text>
            <div class="card-description font-weight-light">
              <p>Name : {{selectedBank.bank_name}}</p>
              <p>Account Number : {{selectedBank.account_number}}</p>
              <p>Routing Number : {{selectedBank.routing_number}}</p>
              <p>
                <a href="#" @click="editBankItem(selectedBank)">
                  <v-icon>mdi-pencil</v-icon>Edit bank account
                </a>
              </p>
              <p>
                <a href="#" @click="deleteBankItem(selectedBank)">
                  <v-icon>mdi-delete</v-icon>Delete bank account
                </a>
              </p>
              <p>
                <a href="#" @click="bankDialog = true">
                  <v-icon>mdi-plus-circle</v-icon>Add new bank account
                </a>
              </p>
            </div>
          </v-card-text>
        </material-card>
      </v-flex>

      <!-- Bank dialog -->
      <v-dialog v-model="bankDialog" max-width="400px">
        <v-form @submit.prevent="saveBankDialog">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedBankItem.bank_name"
                      label="Name"
                      name="bank name"
                      v-validate="'required|max:15'"
                      :counter="15"
                      :error-messages="errors.collect('bank name')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedBankItem.account_number"
                      label="Account#"
                      name="account number"
                      v-validate="'required|max_value:999999999'"
                      :error-messages="errors.collect('account number')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedBankItem.routing_number"
                      label="Routing#"
                      name="routing number"
                      v-validate="'required|max_value:999999999'"
                      :error-messages="errors.collect('routing number')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedBankItem.bank_external_id" label="ID" disabled></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedBankItem.bank_alias" label="Alias" disabled></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="closeBankDialog">Cancel</v-btn>
              <v-btn color="blue darken-1" flat @click="saveBankDialog">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-flex xs12 md8>
        <v-layout row wrap>
          <v-flex md6 sm12>
            <material-stats-card
              color="orange"
              icon="mdi-currency-usd"
              title="YTD Deposit"
              :value="selectedBank.YTDDeposit | toCurrency"
              sub-icon="mdi-update"
              sub-text="Just Updated"
            />
          </v-flex>
          <v-flex md6 sm12>
            <material-stats-card
              color="red"
              icon="mdi-information-outline"
              title="Unreconciled Deposit"
              text-color="error"
              :value="selectedBank.unreconciledAmount | toCurrency"
              sub-icon="mdi-update"
              sub-text="Just Updated"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md12>
            <p>Upload bank transactions</p>
            <vue-dropzone id="drop1" :options="dropOptions" :include-styling="true"></vue-dropzone>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md12 lg12>
        <material-card
          color="orange"
          title="Bank Transactions"
          text="Transactions for this bank account"
        >
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <!--Date picker-->
                <v-flex xs12 sm6 md4>
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date"
                        label="Begin Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      @input="menu1 = false"
                      header-color="primary"
                      no-title
                      dark
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <!--End Date picker-->

                <!--Date picker-->
                <v-flex xs12 sm6 md4>
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date2"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date2"
                      @input="menu2 = false"
                      header-color="primary"
                      no-title
                      dark
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <!--End Date picker-->
                <v-flex xs12 sm6 md4>
                  <v-btn round color="primary" dark @click="depositDialog=true">Add Deposit</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-data-table :headers="headers" :items="deposits">
            <template slot="headerCell" slot-scope="{ header }">
              <span class="font-weight-light text-warning text--darken-3" v-text="header.text" />
            </template>
            <template slot="items" slot-scope="{ index, item }">
              <td>{{ item.deposit_date }}</td>
              <td>{{ item.deposit_external_id }}</td>
              <td>{{ item.deposit_type_external_id }}</td>
              <td>{{ item.amount | toCurrency }}</td>
              <td>
                <v-tooltip top content-class="top">
                  <v-icon slot="activator" small @click="editDepositItem(item)">mdi-pencil</v-icon>
                  <span>Edit</span>
                </v-tooltip>
                <v-tooltip top content-class="top">
                  <v-icon slot="activator" small @click="deleteDepositItem(item)">mdi-delete</v-icon>
                  <span>Delete</span>
                </v-tooltip>
                <v-tooltip top content-class="top">
                  <v-icon slot="activator" small @click="editDepositItem(item)">mdi-link-off</v-icon>
                  <span>Unlink</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>

    <!-- Deposit dialog -->
    <v-dialog v-model="depositDialog" max-width="1000px">
      <v-form @submit.prevent="saveBankDepositDialog">
        <v-card>
          <v-card-title>
            <span class="headline">Add Deposit</span>
          </v-card-title>

          <v-card-text>
            <!-- <v-container grid-list-md> -->
            <material-card color="orange" title="Deposit">
              <v-layout wrap>
                <v-flex xs12 sm6 md2></v-flex>
                <v-flex xs12 sm6 md2></v-flex>
                <v-flex xs12 sm6 md2></v-flex>
                <v-flex xs12 sm6 md2></v-flex>
                <v-flex xs12 sm6 md2>
                  <v-text-field
                    v-model="editedDepositItem.deposit_external_id"
                    label="Deposit ID"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-text-field v-model="editedDepositItem.amount" label="Total Amount" disabled></v-text-field>
                </v-flex>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md2>
                    <v-text-field v-model="editedDepositItem.deposit_date" label="Date"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md2>
                    <v-text-field
                      v-model="editedDepositItem.deposit_reference_number"
                      label="Reference#"
                      name="Deposit reference"
                      v-validate="'required|max:50'"
                      :error-messages="errors.collect('deposit reference')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md2>
                    <v-text-field
                      v-model="editedDepositItem.deposit_cleared_date"
                      label="Cleared Date"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md2>
                    <v-select
                      label="Deposit Type"
                      :items="depositTypes"
                      v-model="editedDepositItem.deposit_type_external_id"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-system-bar>
                      <span>Transactions</span>
                      <v-btn color="primary" flat @click="addTransaction">Add row</v-btn>
                    </v-system-bar>
                  </v-flex>
                </v-layout>

                <div
                  v-for="transaction in transactions"
                  :key="transaction.deposit_transaction_external_id  "
                >
                  <v-layout wrap>
                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        v-model="transaction.deposit_transaction_external_id"
                        label="Transaction ID"
                        disabled
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-select
                        label="Payer"
                        :items="payers"
                        v-model="transaction.carrier_external_id"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        v-model="transaction.deposit_transaction_reference_number"
                        label="Reference#"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-select
                        v-model="transaction.statement_external_id"
                        :items="commissionStatements"
                        label="Statement"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md2></v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-text-field v-model="transaction.amount" label="Amount"></v-text-field>
                    </v-flex>
                  </v-layout>
                </div>
                <v-layout wrap>
                  <v-flex xs12 sm6 md3>
                    <v-btn color="primary" flat @click="addTransaction">Add row</v-btn>
                  </v-flex>
                </v-layout>
              </v-layout>
            </material-card>
            <!-- </v-flex> -->

            <!-- </v-container> -->
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeDepositDialog">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="saveDepositDialog">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import BankService from "@/api-services/bank.service.js";
import vueDropzone from "vue2-dropzone";
// Utilities
import { mapActions, mapMutations } from "vuex";
import { mapMultiRowFields } from "vuex-map-fields";
import { constants } from "crypto";
import _ from "lodash";
export default {
  created() {
    this.setColor("orange"), this.initialize();
  },
  data() {
    return {
      //Bank objects
      bankDialog: false,
      banks: [],
      selectedBank: null,
      editedBankIndex: -1,
      editedBankItem: {
        bank_external_id: "",
        user_external_id: "",
        bank_alias: "",
        bank_name: "",
        account_number: "",
        routing_number: "",
        is_active: true,
        YTDDeposit: 0.0,
        unreconciledAmount: 0.0,
        create_user: "",
        modify_user: "",
        create_date: "",
        modify_date: ""
      },
      defaultBankItem: {
        bank_external_id: "",
        user_external_id: "",
        bank_alias: "",
        bank_name: "",
        account_number: "",
        routing_number: "",
        is_active: true,
        YTDDeposit: 0.0,
        unreconciledAmount: 0.0,
        create_user: "",
        modify_user: "",
        create_date: "",
        modify_date: ""
      },

      //Bank Deposits
      depositDialog: false,
      editedDepositIndex: -1,
      deposits: [],
      editedDepositItem: {
        id: 0,
        user_external_id: "",
        bank_external_id: "",
        deposit_external_id: "",
        deposit_date: new Date().toISOString().substr(0, 10),
        deposit_reference_number: "",
        deposit_cleared_date: new Date().toISOString().substr(0, 10),
        deposit_type_external_id: "",
        amount: 0.0,
        is_active: true,
        create_user: "",
        update_user: ""
      },
      defaultDepositItem: {
        user_external_id: "",
        bank_external_id: "",
        deposit_external_id: "",
        deposit_date: new Date().toISOString().substr(0, 10),
        deposit_reference_number: "",
        deposit_cleared_date: new Date().toISOString().substr(0, 10),
        deposit_type_external_id: "",
        amount: 0.0,
        is_active: true,
        create_user: "",
        update_user: ""
      },
      depositTypes: ["Check", "ACH"],

      //BANK DEPOSIT TRANSACTIONS

      color: "orange",
      selectedCarrier: "",

      selectedStatements: [],
      payers: ["BCBSIL", "Aetna", "UHC"],
      commissionStatements: [
        "02/01/2019 - $43,900",
        "03/01/2019 - $700",
        "04/01/2019 - $9,100",
        "05/01/2019 - $11"
      ],

      dropOptions: {
        url: "https://httpbin.org/post",
        maxFilesize: 2, // MB
        maxFiles: 4,
        chunking: true,
        chunkSize: 500, // Bytes
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        addRemoveLinks: true
      },
      selected: ["Matched", "Unmatched"],
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      headers: [
        {
          sortable: false,
          text: "Date",
          value: "deposit_date"
        },
        {
          sortable: false,
          text: "Deposit ID",
          value: "deposit_external_id"
        },
        {
          sortable: false,
          text: "Type",
          value: "deposit_type_external_id"
        },
        {
          sortable: false,
          text: "Amount",
          value: "amount"
        },
        {
          sortable: false,
          text: "Action",
          value: "action"
        }
      ]
    };
  },
  components: {
    vueDropzone
  },
  computed: {
    formTitle() {
      return this.editedBankIndex === -1
        ? "New Bank Account"
        : "Edit Bank Account";
    },
    // The `mapMultiRowFields()` function of
    // the vuex-map-fields package, makes it
    // possible to dynamically map the fields
    // of multiple rows of data, to Vuex conform
    // getter and setter functions.
    ...mapMultiRowFields(["transactions"])
  },
  methods: {
    initialize() {
      BankService.getUserBank("user0001")
        .then(response => {
          var bank = response.data.bank;
          this.banks = _.toArray(bank);
          console.log(this.banks);
          this.selectedBank = this.banks[0];
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },

    setColor(color) {
      this.$store.state.app.color = color;
    },

    // We're using the native Vuex function
    // `mapMutations()` to map our mutation
    // for adding a new address row, to a
    // method with the same name as the mutation.
    ...mapMutations(["addTransaction"]),

    // selectBank(bank) {
    //   this.selectedBank = bank;
    // },

    //Bank Deposit Methods

    editDepositItem(item) {
      this.editedDepositIndex = this.deposits.indexOf(item);
      this.editedDepositItem = Object.assign({}, item);

      //Get Transactions
      BankService.getTransactionsByDeposit(
        this.editedDepositItem.deposit_external_id
      )
        .then(response => {
          var transactions = response.data.bank_deposit_transaction;
          this.$store.state.transactions = _.toArray(transactions);
          console.log(transactions);
        })
        .catch(error => {
          console.log(error.response.data);
        });

      this.depositDialog = true;
    },

    deleteDepositItem(item) {
      const index = this.deposits.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.deposits.splice(index, 1);
      BankService.deleteTransactionsByDeposit(item.deposit_external_id)
        .then(response => {
          console.log(response);
          if (response.status == 200) {
            BankService.deleteBankDeposit(item.id)
              .then(response => {
                console.log(response);
                if (response.status == 200) {
                  this.$toasted.show(
                    "Bank Deposit details deleted successfully.",
                    {
                      theme: "bubble",
                      position: "top-right",
                      duration: 5000,
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    }
                  );
                }
              })
              .catch(error => {
                console.log(error);
                this.$toasted.show(error);
              });
          }
        })
        .catch(error => {
          console.log(error);
          this.$toasted.show(error);
        });

      this.$store.state.transactions = [];
    },

    closeDepositDialog() {
      this.depositDialog = false;
      setTimeout(() => {
        this.editedDepositItem = Object.assign({}, this.defaultDepositItem);
        this.editedDepositIndex = -1;
        this.$store.state.transactions = [];
      }, 300);
    },

    saveDepositDialog() {
      this.$validator.validateAll().then(result => {
        result = true;
        if (result) {
          if (this.editedDepositIndex > -1) {
            Object.assign(
              this.deposits[this.editedDepositIndex],
              this.editedDepositItem
            );

            BankService.updateBankDeposit(
              this.editedDepositItem.id,
              this.editedDepositItem
            )
              .then(response => {
                console.log(response);
                if (response.status == 200) {
                  this.$toasted.show(
                    "Bank Deposit details updated successfully.",
                    {
                      theme: "bubble",
                      position: "top-right",
                      duration: 5000,
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    }
                  );
                }
              })
              .catch(error => {
                console.log(error);
                this.$toasted.show(error);
              });

            //Assign Deposit ID to transaction
            _.forEach(this.transactions, (item, i) => {
              item.deposit_external_id = this.editedDepositItem.deposit_external_id;
              item.statement_external_id = "S1123";
            });

            let data = _.cloneDeep(this.$store.state.transactions);

            BankService.bulkCreateBankDepositTransaction(data)
              .then(response => {
                console.log(response);
                if (response.status == 200) {
                  this.$toasted.show(
                    "Bank Deposit Transactions created successfully.",
                    {
                      theme: "bubble",
                      position: "top-right",
                      duration: 5000,
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    }
                  );
                }
              })
              .catch(error => {
                console.log(error);
                this.$toasted.show(error);
              });
          } else {
            this.editedDepositItem.user_external_id = "user0001";
            this.editedDepositItem.bank_external_id = this.selectedBank.bank_external_id;
            this.editedDepositItem.create_user = this.$store.state.current_user.user_external_id;
            this.editedDepositItem.update_user = this.$store.state.current_user.user_external_id;
            this.deposits.push(this.editedDepositItem);
            BankService.createBankDeposit(this.editedDepositItem)
              .then(response => {
                console.log(response);
                if (response.status == 200) {
                  this.$toasted.show("Bank Deposit created successfully.", {
                    theme: "bubble",
                    position: "top-right",
                    duration: 5000,
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  });
                }
              })
              .catch(error => {
                console.log(error);
                this.$toasted.show(error);
              });

            //Assign Deposit ID to transaction
            _.forEach(this.transactions, (item, i) => {
              item.deposit_external_id = this.editedDepositItem.deposit_external_id;
              item.create_user=this.$store.state.current_user.user_external_id;
              item.update_user=this.$store.state.current_user.user_external_id;
              item.statement_external_id = "S1123";
            });

            let data = _.cloneDeep(this.$store.state.transactions);

            BankService.bulkCreateBankDepositTransaction(data)
              .then(response => {
                console.log(response);
                if (response.status == 200) {
                  this.$toasted.show(
                    "Bank Deposit Transactions created successfully.",
                    {
                      theme: "bubble",
                      position: "top-right",
                      duration: 5000,
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    }
                  );
                }
              })
              .catch(error => {
                console.log(error);
                this.$toasted.show(error);
              });
          }
          this.depositDialog = false;
          this.$store.state.transactions = [];
        }
      });
    },

    //Bank Methods

    editBankItem(item) {
      this.editedBankIndex = this.banks.indexOf(item);
      this.editedBankItem = Object.assign({}, item);
      this.bankDialog = true;
    },

    deleteBankItem(item) {
      const index = this.banks.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.banks.splice(index, 1);
      BankService.deleteBank(item.bank_external_id);
      this.selectedBank = this.banks[0];
    },

    closeBankDialog() {
      this.bankDialog = false;
      setTimeout(() => {
        this.editedBankItem = Object.assign({}, this.defaultBankItem);
        this.editedBankIndex = -1;
      }, 300);
    },

    saveBankDialog() {
      this.$validator.validateAll().then(result => {
        result=true;
        if (result) {
          if (this.editedBankIndex > -1) {
            Object.assign(
              this.banks[this.editedBankIndex],
              this.editedBankItem
            );
            console.log(this.banks);
            BankService.updateBank(this.editedBankItem.id, this.editedBankItem)
              .then(response => {
                console.log(response);
                if (response.status == 200) {
                  this.$toasted.show("Bank details updated successfully.", {
                    theme: "bubble",
                    position: "top-right",
                    duration: 5000,
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  });
                }
              })
              .catch(error => {
                console.log(error);
                this.$toasted.show(error);
              });
          } else {
            this.editedBankItem.user_external_id = "user0001";
            this.editedBankItem.create_user = this.$store.state.current_user.user_external_id;
            this.editedBankItem.update_user = this.$store.state.current_user.user_external_id;
            this.banks.push(this.editedBankItem);
            BankService.createBank(this.editedBankItem)
              .then(response => {
                console.log(response);
                if (response.status == 200) {
                  this.$toasted.show("Bank created successfully.", {
                    theme: "bubble",
                    position: "top-right",
                    duration: 5000,
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  });
                }
              })
              .catch(error => {
                console.log(error);
                this.$toasted.show(error);
              });
          }
          this.selectedBank = this.editedBankItem;
          this.bankDialog = false;
        }
      });
    }
  },
  watch: {
    depositDialog(val) {
      val || this.closeDepositDialog();
    },
    bankDialog(val) {
      val || this.closeBankDialog();
    },
    editedBankItem: {
      handler(val, oldVal) {
        val.bank_alias =
          val.bank_name.slice(0, 3) + "(" + val.account_number.slice(-4) + ")";
        if (val.bank_external_id == "")
          val.bank_external_id =
            "B" + Math.floor(Math.random() * (1000000000 - 1 + 1)) + 1;
      },
      deep: true
    },
    editedDepositItem: {
      handler(val, oldVal) {
        val.amount=this.transactions.reduce((a, n) => (a + Number(n.amount)), 0);
        if (val.deposit_external_id == "")
          val.deposit_external_id =
            "DEP" + Math.floor(Math.random() * (1000000000 - 1 + 1)) + 1;
      },
      deep: true
    },
    selectedBank(val) {
      //Bank Deposits
      BankService.getDepositsByBank(this.selectedBank.bank_external_id)
        .then(response => {
          var bankDeposits = response.data.bank_deposit;
          this.deposits = _.toArray(bankDeposits);
          console.log(this.deposits);
        })
        .catch(error => {
          console.log(error.response.data);
        });
    }
  }
};
</script>
